import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getStreamSrc } from "@tvg/utils/pastPerformanceUtils";
import { getIsLogged } from "@urp/store-selectors";
import { RaceProgram } from "@tvg/ts-types/Race";

type UseGetReplayVideoSrc = (
  currentRace: RaceProgram | undefined,
  isAllowedToRequest: boolean
) => string | undefined;

interface GetStreamResponse {
  payload: string | object;
  type: string;
}

// Warning the usage of this code forces implicates that in testing you need to mock the request to the server
export const useGetReplayVideoSrc: UseGetReplayVideoSrc = (
  currentRace,
  isAllowedToRequest = true
) => {
  const isLogged = useSelector(getIsLogged);
  const [replaySource, setReplaySource] = useState<string | undefined>();

  useEffect(() => {
    if (
      !isLogged ||
      !isAllowedToRequest ||
      !currentRace?.video?.replayFileName
    ) {
      if (replaySource) {
        setReplaySource(undefined);
      }
      return;
    }

    getStreamSrc(currentRace.video.replayFileName)
      .then(({ payload: tempReplaySrc, type }: GetStreamResponse) => {
        if (
          tempReplaySrc &&
          typeof tempReplaySrc === "string" &&
          type === "success"
        ) {
          setReplaySource(
            tempReplaySrc
              .replace("replaysmobile.m3u8", "replaysflash.php")
              .replace("race=", "stream=")
              .concat("&width=100%&height=100%")
          );
        }
      })
      .catch(() => null);
  }, [isLogged, isAllowedToRequest, currentRace?.video?.replayFileName]);

  return replaySource;
};

export default useGetReplayVideoSrc;
